import { Modal } from 'antd';

import { getProName } from '../getProName/getProName';

export const modalErrorReport = () =>
  Modal.error({
    title: 'Limite mensal deste relatório atingido!',
    content: (
      <div style={{ fontWeight: 300 }}>
        Caso deseje gerar mais relatórios, será necessário fazer upgrade para a
        versão <strong style={{ fontWeight: 700 }}>{getProName()}</strong>.
      </div>
    ),
  });
